import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, first, map, tap } from 'rxjs';
import { RouterSelectors } from '../../../state/router.selectors';
import { LyaActions } from '../state/lya.actions';
import { LyaSelectors } from '../state/lya.selectors';

export const LyaAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  store
    .select(RouterSelectors.selectParams)
    .pipe(
      filter((params) => !!params),
      first(),
      tap((params) => {
        store.dispatch(new LyaActions.getCandidateInterviewMeta(params['id'], params['companyId']));
      }),
    )
    .subscribe();
  const router = inject(Router);
  return store.select(LyaSelectors.conversationMeta).pipe(
    filter((metaData) => !!metaData),
    map((metaData) => {
      if (!metaData || metaData.status === 'DONE') {
        router.navigateByUrl('/404');
        return false;
      }
      return true;
    }),
  );
};
